// ==================================================
// Area 37 js methods
//
// Copyright 2024 Doctor Shop Srl
//
// ==================================================

(function () {
    "use strict";

    window.onload = function () {
        window.setTimeout(fadeout, 500);
    }

    function fadeout() {
        document.querySelector('.preloader').style.opacity = '0';
        document.querySelector('.preloader').style.display = 'none';
    }
    
})()

function SalvaTermini() {
    waitingBS.Show();
    var formstate = true;
    var scroll = true;
    var cbcondizioni1 = $('#regsrv1')[0];
    var cbcondizioni2 = $('#regsrv2')[0];
    if (cbcondizioni1 != null && cbcondizioni1 != undefined && cbcondizioni2 != null && cbcondizioni2 != undefined) {
        if (!cbcondizioni1.checked && !cbcondizioni2.checked) {
            $('#chkp1').html(mainController.GetLabel('lErroreCommerciale'));
            $('#lErroreSrv').addClass('is-invalid');
            scroll = false;
            formstate = false;
        }
        else if (!cbcondizioni1.checked && cbcondizioni2.checked) {
            $('#chkp1').html(mainController.GetLabel('lErroreServizio'));
            $('#lErroreSrv').addClass('is-invalid');
            scroll = false;
            formstate = false;
        }
    }
    else {
        scroll = false;
        formstate = false;
    }

    var cbmarketing1 = $('#regmktg1')[0];
    var cbmarketing2 = $('#regmktg2')[0];
    if (cbmarketing1 != null && cbmarketing1 != undefined && cbmarketing2 != null && cbmarketing2 != undefined) {
        if (!cbmarketing1.checked && !cbmarketing2.checked) {
            $('#lErroreMktg').addClass('is-invalid');
            scroll = false;
            formstate = false;
        }
    }
    else {
        scroll = false;
        formstate = false;
    }

    var cbprofilazione1 = $('#regprof1')[0];
    var cbprofilazione2 = $('#regprof2')[0];
    if (cbprofilazione1 != null && cbprofilazione1 != undefined && cbprofilazione2 != null && cbprofilazione2 != undefined) {
        if (!cbprofilazione1.checked && !cbprofilazione2.checked) {
            $('#lErroreProf').addClass('is-invalid');
            scroll = false;
            formstate = false;
        }
    }
    else {
        scroll = false;
        formstate = false;
    }

    if (formstate) {
        setTimeout(function () {
            waitingBS.Hide();
        }, 3000);
        return true;
    }
    else {
        waitingBS.Hide();
        if (scroll) {
            $(window).scrollTop(0);
        }
        return false;
    }
}

function UpdateEditProfiloForm(model) {
    try {
        waitingBS.Show();

        if (parseInt(id) > 0) {

            $.ajax({
                url: '/Account/RefreshFormRegistrazioneProfiloUtente',
                type: 'POST',
                data: model,
                success: function (result) {
                    $("#form-content").removeClass('disabledfn');
                    $("#form-content").html(result);
                    waitingBS.Hide();
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    console.log(xhr);
                    waitingBS.Hide();
                }
            });


        }
        else {
            $("#form-content").addClass("disabledfn");
            waitingBS.Hide();
        }
    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
}

/**
 * Effettua la validazione del form di modifica
 * @param {any} lcid
 */
function UpdateUser(lcid) {
    waitingBS.Show();

    try {
        var formstate = true;
        var scroll = true;
        var usertype = parseInt($("#reg-tipologiaprofiloutente").val());

        $("form#feditprofilo :input").each(function (index, value) {
            if ($(this).attr('required')) {
                if ($(this).val() == null || $(this).val() == undefined || $(this).val() == '') {
                    $(this).addClass('is-invalid');
                    formstate = false;
                }
                else {
                    $(this).removeClass('is-invalid');
                }
            }
            else {
                $(this).removeClass('is-invalid');
            }
        });

        var titolo = $('#reg-titolo');
        if (titolo == null || titolo == undefined || titolo.val() == '' || parseInt(titolo.val()) == 0) {
            titolo.addClass('is-invalid');
            formstate = false;
        }

        switch (lcid) {
            case 1034:
                if (!ESDoc($("#reg-piva").val())) {
                    $("#reg-piva").addClass('is-invalid');
                    formstate = false;
                }
                break;
            case 1040:
                var capf = $("#reg-fcap").val();
                var isnumCap = /^\d+$/.test(capf);
                if (!isnumCap || capf.length < 5) {
                    $("#reg-fcap").addClass('is-invalid');
                    formstate = false;
                }

                var iban = $("#reg-fiban").val();
                if (iban !== null && iban.length > 0) {
                    if (!smellsLikeIban(iban) || !validateIbanChecksum(iban)) {
                        $("#reg-fiban").addClass('is-invalid');
                        formstate = false;
                    }
                }

                var icc = $("#reg-ficc").val();
                if (icc !== null || icc.length < 3) {
                    $("#reg-ficc").addClass('is-invalid');
                    formstate = false;
                }

                switch (usertype) {
                    case 1: //privato
                    case 7: //professionista senza p.iva
                        if ($("#reg-cf").val() !== 'undefined' && !mainController.CheckCodiceFiscale($("#reg-cf").val())) {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        break;
                    case 2: //azienda - p.iva
                    case 4: //pubblica amministrazione
                        var pec = $("#reg-fpec").val().trim();
                        var sdi = $("#reg-fsdi").val().trim();

                        if (($("#reg-piva").val() === '') && ($("#reg-cf").val() === '')) {
                            $("#reg-piva").addClass('is-invalid');
                            formstate = false;
                        }
                        else {
                            if (!mainController.CheckPartitaIva($("#reg-piva").val())) {
                                $("#reg-piva").addClass('is-invalid');
                                formstate = false;
                            }

                            if (($("#reg-cf").val() !== '') && (!mainController.CheckCodiceFiscale($("#reg-cf").val()))) {
                                $("#reg-cf").addClass('is-invalid');
                                formstate = false;
                            }
                        }
                        if (sdi === "" && pec === "") {
                            $("#reg-fsdi").addClass('is-invalid');
                            $("#reg-fpec").addClass('is-invalid');
                            $("#msgsdi").html(mainController.GetLabel('lErroreFattElettronica'));
                            formstate = false;
                        }
                        else {
                            if (sdi != "" && sdi.length !== 7) {
                                $("#reg-fsdi").addClass('is-invalid');
                                $("#msgsdi").html(mainController.GetLabel('lErroreSDILunghezza'));
                                formstate = false;
                            }
                            else if (sdi != "" && sdi === "0000000" && (pec === "")) {
                                $("#reg-fsdi").addClass('is-invalid');
                                $("#msgsdi").html(mainController.GetLabel('lErroreSDIZero'));
                                formstate = false;
                            }
                        }
                        break;
                    case 3://onlus
                        if ($("#reg-cf").val() === 'undefined') {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        else {
                            formstate = mainController.CheckCodiceFiscale($("#reg-cf").val());
                        }
                        break;
                    case 6: //forfettario
                        if ($("#reg-cf").val() !== 'undefined' && !mainController.CheckCodiceFiscale($("#reg-cf").val())) {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }

                        if ($("#reg-piva").val() === 'undefined' || !mainController.CheckPartitaIva($("#reg-piva").val())) {
                            $("#reg-piva").addClass('is-invalid');
                            formstate = false;
                        }
                        break;

                }
                break;
        }
        if (formstate) {
            return true;
        }
        else {
            waitingBS.Hide();
            if (scroll) {
                $(window).scrollTop(0);
            }
            return false;
        }
    } catch (e) {
        waitingBS.Hide();
        $(window).scrollTop(0);
        console.log(e);
        return false;
    }

}
/**
 * Effettua la validazione del form di registrazione in base alla lingua.
 * @param {any} lcid
 * @returns
 */
function RegisterUser(lcid) {
    waitingBS.Show();

    try {
        var formstate = true;
        var scroll = true;
        var usertype = parseInt($("#reg-tipologiacliente").val());
        var p1 = $("#regsrv1").prop('checked');

        if (!$("#cbshippingsameaddress")[0].checked) {
            copyaddress(true);
        }

        $("form#fregistrazione :input").each(function (index, value) {
            if (!$(this)[0].closest("#panel-spedizione") || ($(this)[0].closest("#panel-spedizione") && $("#cbshippingsameaddress")[0].checked)) {
                if ($(this).attr('required')) {
                    if ($(this).val() == null || $(this).val() == undefined || $(this).val() == '') {
                        $(this).addClass('is-invalid');
                        formstate = false;
                    }
                    else {
                        $(this).removeClass('is-invalid');
                    }
                }
                else {
                    $(this).removeClass('is-invalid');
                }
            }
        });

        if (!CheckPassword()) {
            formstate = false;
        }

        if (!mainController.CheckEmail($('#reg-email').val())) {
            $('#reg-email').addClass('is-invalid');
            formstate = false;
        }

        var titolo = $('#reg-titolo');
        if (titolo == null || titolo == undefined || titolo.val() == '' || parseInt(titolo.val()) == 0) {
            titolo.addClass('is-invalid');
            formstate = false;
        }

        // Condizioni generali di vendita
        var cbcondizioni1 = $('#regsrv1')[0]; //accetto
        var cbcondizioni2 = $('#regsrv2')[0]; //non accetto
        if (cbcondizioni1 != null && cbcondizioni1 != undefined && cbcondizioni2 != null && cbcondizioni2 != undefined) {
            if (!cbcondizioni1.checked && !cbcondizioni2.checked) { // non ho scelto nulla
                $('#chkp1').html(mainController.GetLabel('lErroreCommerciale'));
                $('#lErroreSrv').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
            else if (!cbcondizioni1.checked && cbcondizioni2.checked) { // ho scelto di non accettare
                $('#chkp1').html(mainController.GetLabel('lErroreServizio'));
                $('#lErroreSrv').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        // Privacy per marketing
        var cbmarketing1 = $('#regmktg1')[0];
        var cbmarketing2 = $('#regmktg2')[0];
        if (cbmarketing1 != null && cbmarketing1 != undefined && cbmarketing2 != null && cbmarketing2 != undefined) {
            if (!cbmarketing1.checked && !cbmarketing2.checked) {
                $('#lErroreMktg').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        // Privacy per profilazione
        var cbprofilazione1 = $('#regmktg1')[0];
        var cbprofilazione2 = $('#regmktg2')[0];
        if (cbprofilazione1 != null && cbprofilazione1 != undefined && cbprofilazione2 != null && cbprofilazione2 != undefined) {
            if (!cbprofilazione1.checked && !cbprofilazione2.checked) {
                $('#lErroreProf').addClass('is-invalid');
                scroll = false;
                formstate = false;
            }
        }
        else {
            scroll = false;
            formstate = false;
        }

        var cf = $("#reg-cf").val();

        switch (lcid) {
            case 1034:
                var partitaiva = $("#reg-piva").val();
                if (partitaiva != null && partitaiva != undefined) {
                    if (!ESDoc(partitaiva)) {
                        $("#reg-piva").addClass('is-invalid');
                        formstate = false;
                    }
                }
                break;
            case 1040:
                var capf = $("#reg-fcap").val();
                var isnumCap = /^\d+$/.test(capf);
                if (!isnumCap || capf.length != 5) {
                    $("#reg-fcap").addClass('is-invalid');
                    formstate = false;
                }

                switch (usertype) {
                    case 1: //privato            
                    case 7: //professionista senza p.iva
                        if (cf != undefined && !mainController.CheckCodiceFiscale(cf)) {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        break;
                    case 2: //azienda - p.iva
                    case 4: //pubblica amministrazione
                        var pec = $("#reg-fpec").val().trim();
                        var sdi = $("#reg-fsdi").val().trim();

                        if (($("#reg-piva").val() === '') && (cf === '')) {
                            $("#reg-piva").addClass('is-invalid');
                            formstate = false;
                        }
                        else {
                            if (!mainController.CheckPartitaIva($("#reg-piva").val().trim())) {
                                $("#reg-piva").addClass('is-invalid');
                                formstate = false;
                            }

                            if ((cf !== '') && (!mainController.CheckCodiceFiscale(cf))) {
                                $("#reg-cf").addClass('is-invalid');
                                formstate = false;
                            }
                        }

                        if (sdi === "" && pec === "") {
                            $("#reg-fsdi").addClass('is-invalid');
                            $("#reg-fpec").addClass('is-invalid');
                            $("#msgsdi").html(mainController.GetLabel('lErroreFattElettronica'));
                            formstate = false;
                        }
                        else {
                            if (sdi != "" && sdi.length !== 7) {
                                $("#reg-fsdi").addClass('is-invalid');
                                $("#msgsdi").html(mainController.GetLabel('lErroreSDILunghezza'));
                                formstate = false;
                            }
                            else if (sdi != "" && sdi === "0000000" && (pec === "")) {
                                $("#reg-fsdi").addClass('is-invalid');
                                $("#msgsdi").html(mainController.GetLabel('lErroreSDIZero'));
                                formstate = false;
                            }
                            else if (sdi == "" && pec != "" && !mainController.CheckEmail(pec)) {
                                $("#reg-fpec").addClass('is-invalid');
                                $("#msgpec").html(mainController.GetLabel('lErrorePEC'));
                                formstate = false;
                            }
                        }
                        break;
                    case 3://onlus
                        if (cf == undefined || cf == null || cf == '') {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        else if (!/^[0-9]{11}$/.test(cf)) {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        break;
                    case 6: //forfettario
                        if (cf === 'undefined') {
                            $("#reg-cf").addClass('is-invalid');
                            formstate = false;
                        }
                        else {
                            if (!mainController.CheckCodiceFiscale(cf)) {
                                $("#reg-cf").addClass('is-invalid');
                                formstate = false;
                            }
                        }

                        if ($("#reg-piva").val() === 'undefined' || !mainController.CheckPartitaIva($("#reg-piva").val())) {
                            $("#reg-piva").addClass('is-invalid');
                            formstate = false;
                        }

                        break;
                }
                break;
        }

        /* check recapito telefonico fatturazione */
        var ftel = $("#reg-ftelefono").val().trim();
        var fcel = $("#reg-fcellulare").val().trim();

        if (ftel === "" && fcel === "") {
            $("#reg-ftelefono").addClass('is-invalid');
            $("#reg-fcellulare").addClass('is-invalid');
            $("#chkfrecapito").html(mainController.GetLabel('lAvvisoRecapito'));
            formstate = false;
        }

        /* check recapito telefonico spedizione */
        if ($("#cbshippingsameaddress")[0].checked) {
            var stel = $("#reg-stelefono").val().trim();
            var scel = $("#reg-scellulare").val().trim();
            if (stel === "" && scel === "") {
                $("#reg-stelefono").addClass('is-invalid');
                $("#reg-scellulare").addClass('is-invalid');
                $("#chkfrecapitos").html(mainController.GetLabel('lAvvisoRecapito'));
                formstate = false;
            }
        }

        /** check privacy */
        if (typeof p1 === 'undefined') {
            $("#regsrv1").addClass('is-invalid');
            $("#chkp1").html(mainController.GetLabel('lErroreCommerciale'));
            formstate = false;
        }

        if (formstate) {
            if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                    'event': 'sign_up',
                    'method': 'registrazione',
                    'email': $("#reg-email").val()
                });
            }
            setTimeout(function () {
                waitingBS.Hide();
            }, 3000);
            return true;
        }
        else {
            waitingBS.Hide();
            if (scroll) {
                $(window).scrollTop(0);
            }
            return false;
        }
    } catch (e) {
        waitingBS.Hide();
        $(window).scrollTop(0);
        console.log(e);
        return false;
    }
}

/**
 * Copia i campi dell'indirizzo di fattuazione in quello di spedizione.
 */
function copyaddress(forced) {
    if ($("#cbshippingsameaddress").checked || forced) {
        $("#reg-sindirizzo").val($("#reg-findirizzo").val());
        $("#reg-scitta").val($("#reg-fcitta").val());
        $("#reg-scap").val($("#reg-fcap").val());
        $("#reg-sprovincia").val($("#reg-fprovincia").val());
        $("#reg-snazione").val($("#reg-fnazione").val());
        $("#reg-stelefono").val($("#reg-ftelefono").val());
        $("#reg-scellulare").val($("#reg-fcellulare").val());
        $("#reg-sragsoc").val($("#reg-fragionesociale").val());
        $("#reg-snome").val($("#reg-fnome").val() + " " + $("#reg-fcognome").val())
    }
    else {
        $("#reg-sindirizzo").val('');
        $("#reg-scitta").val('');
        $("#reg-scap").val('');
        $("#reg-sprovincia").val('');
        $("#reg-snazione").val('');
        $("#reg-stelefono").val('');
        $("#reg-scellulare").val('');
        $("#reg-sragsoc").val('');
        $("#reg-snome").val('');
    }
}

function UpdateDDLProvincia() {
    var country = $('#reg-fnazione').val();

    switch (country) {
        case "LI":
        case "SM":
            $('#reg-fprovincia')[0].disabled = true;
            break;
        case "CH":
        case "IT":
        default:
            $('#reg-fprovincia')[0].disabled = false;
            break;
    }
}

function ConfirmBasket() {
    waitingBS.Show("Attendere prego", "sm");
    try {
        var formstate = true;

        $("form#gvmformcarrello :input").each(function (index, value) {
            $(this).removeClass('is-invalid');
            if ($(this).attr('required') && ($(this)[0].disabled == false || !$(this).attr('disabled'))) {
                if ($(this).val() == null || $(this).val() == undefined || $(this).val() == '') {
                    $(this).addClass('is-invalid');
                    formstate = false;
                }
            }
        });

        if (formstate) {
            return true;
        }
        else {
            waitingBS.Hide();
            $(window).scrollTop(0);
            return false;
        }

    } catch (e) {
        waitingBS.Hide();
        $(window).scrollTop(0);
        console.log(e);
        return false;
    }

}